<template>
  <div :class="{ 'notification': true, 'is-visible': isVisible }">
    <icon
      v-if="type === 'success'"
      name="ok-circle"
      size="m"
      primaryColor="color-success" />
    <icon
      v-if="type === 'error'"
      name="cross-circle"
      size="m"
      primaryColor="color-danger" />
    <icon
      v-if="type === 'notice'"
      name="info-circle"
      size="m"
      primaryColor="color-notice" />
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'notification',
  data () {
    return {
      type: 'notice',
      message: '',
      isVisible: false,
      timeout: false
    };
  },
  mounted () {
    this.$bus.$on('notification-display', this.display);
  },
  methods: {
    display (config) {
      clearTimeout(this.timeout);
      this.type = config.type;
      this.message = config.message;
      this.isVisible = true;

      this.timeout = setTimeout(() => {
        this.hide();
      }, config.lifeTime || 3000);
    },
    hide () {
      this.isVisible = false;
    }
  },
  beforeDestroy () {
    this.$bus.$off('notification-display', this.display);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.notification {
  align-items: center;
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 0 10px rgba(0, 0, 0, .5);
  display: flex;
  left: 50%;
  opacity: 0;
  padding: 1rem 1.5rem;
  position: fixed;
  top: -6rem;
  transform: translateX(-50%);
  transition: all .25s ease-out;
  z-index: 1000000;

  &.is-visible {
    opacity: 1;
    top: 1rem;
  }

  svg {
    margin-right: 1rem;
  }
}

@media (max-width: 1040px) {
  .notification {
    max-width: 90vh;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Notification.vue